// Design System - Spacing Scale
// Inspired by React Native GridSystem approach

export const spacing = {
    tiny: '4px',
    small: '8px',
    medium: '16px',
    mediumLarge: '24px',
    large: '32px',
    xLarge: '40px',
    xxLarge: '48px',
    xxxLarge: '64px',
    huge: '80px'
};

// Legacy aliases for backwards compatibility
spacing.xlarge = spacing.xxLarge;
spacing.xxlarge = spacing.xxxLarge;

// Responsive spacing helpers
export const getSpacing = (size) => spacing[size] || spacing.medium;
